import { Column } from 'further-ui/components/Layout';
import { FC } from 'react';
import FormField from 'further-ui/components/FormField';
import CkEditor from 'components/CkEditor';
import FileUpload from 'components/new/FileUpload';
import { UploadType } from 'further-types/files';
import { Control, Controller } from 'react-hook-form';
import { TrancheFormInput } from '../../useTrancheForm';

type Props = {
  control: Control<TrancheFormInput>;
};

const EmailCustomisation: FC<Props> = ({ control }) => {
  return (
    <Column spacing="lg" fullWidth>
      <FormField
        label='Customise "What to expect now"'
        size="xl"
        tooltip="Adding text here will replace the default 'What to expect now' section text into the 'Payment received' system email. Change this if you have a specific process you wish to explain to investors once they have made their subscription payment."
      >
        <Controller
          control={control}
          name="whatToExpectNow"
          render={({ field }) => (
            <CkEditor
              extraLines={7}
              placeholder="We are now processing your application. If any questions arise as we complete this process, our team may contact you. If you do not hear from us, your subscription has been accepted successfully."
              onChange={field.onChange}
              value={field.value}
            />
          )}
        />
      </FormField>
      <FormField
        label="Add additional attachment"
        size="xl"
        extraInformation="If you wish to add a PDF file to the confirmation email, please attach it here. Please note that the Offering document is automatically attached to this email."
      >
        <Controller
          control={control}
          name="additionalAttachment"
          render={({ field }) => (
            <FileUpload
              hideInputTitle
              maxFiles={1}
              uploadType={UploadType.FundDocuments}
              files={field.value ? [field.value] : []}
              onChange={(files) =>
                field.onChange(files[files.length - 1] ?? null)
              }
              onDeleteFile={() => field.onChange(null)}
            />
          )}
        />
      </FormField>
    </Column>
  );
};

export default EmailCustomisation;
